import React, { Component } from 'react';

class IconPie extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="17"
                fill="none"
                viewBox="0 0 17 17"
            >
                <path
                    fill="#fff"
                    d="M7.114 2.365a.594.594 0 01.594.594v6.333h6.333a.594.594 0 01.588.513l.006.08c0 3.935-3.19 6.73-7.125 6.73A7.125 7.125 0 01.385 9.49c0-3.935 2.794-7.125 6.729-7.125zM9.489.385a7.125 7.125 0 017.125 7.126.594.594 0 01-.594.593H9.49a.594.594 0 01-.594-.593V.979A.594.594 0 019.49.386z"
                ></path>
            </svg>
        );
    }
}

export default IconPie;